<template>
    <div class="row">
        <div class="col">
            <div class="title">
                <span>{{title}}</span>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PageTitle",
        props: ["title"],
        data() {
            return {

            }
        },
        watch: {

        },
        mounted() {
            //console.log("Page title mounted", this.title);
        }
    }
</script>